import { render, staticRenderFns } from "./kpsuInvoice.vue?vue&type=template&id=9f72f1ea&scoped=true"
import script from "./kpsuInvoice.vue?vue&type=script&lang=js"
export * from "./kpsuInvoice.vue?vue&type=script&lang=js"
import style0 from "./kpsuInvoice.vue?vue&type=style&index=0&id=9f72f1ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f72f1ea",
  null
  
)

export default component.exports